import { AppDispatch } from '@redux/store';

import { url } from '@api-config';
import Api from 'Api/Api';
import {
  errorFetchLogDetails,
  initFetchLogDetails,
  successFetchLogDetails,
} from './Ingestion.slice';
import { ILogDetails } from './ingestion.interface';

export const fetchIngestionLogDetails =
  (logId: string) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(initFetchLogDetails());

    try {
      const res: ILogDetails = await Api.get(`${url.ingestionProgressById}/${logId}`);
      dispatch(successFetchLogDetails(res));
    } catch (err) {
      console.warn(err);
      dispatch(errorFetchLogDetails());
    }
  };
